import { useState } from "react";
import { cn } from "../lib/utils";

type AvatarSize = "sm" | "md" | "lg";

interface AvatarProps {
  src?: string;
  alt?: string;
  fallback?: string;
  size?: AvatarSize;
  className?: string;
}

export function Avatar({
  src,
  alt,
  fallback,
  size = "md",
  className,
}: AvatarProps) {
  const [imgError, setImgError] = useState(false);

  return (
    <div className={cn("avatar", `avatar-${size}`, className)}>
      {src && !imgError ? (
        <img
          src={src}
          alt={alt ?? "avatar"}
          className="avatar-img"
          onError={() => setImgError(true)}
        />
      ) : (
        <span className="avatar-fallback">
          {fallback ?? "??"}
        </span>
      )}
    </div>
  );
}
